import { Autocomplete, Box, Button, Card, Input, Typography } from '@mui/joy'
import React, { useEffect, useState } from 'react'
import { post, Token } from '../../../../../../Script/Session';
import { useNavigate } from 'react-router-dom';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
function CreateTarifform({ gesellschaften, setcr, subkathid }) {
  const [name, setname] = useState("");
  const [gesellschaftid, setgesellschaftid] = useState(null);
  const [currenttarifart, setcurrenttarifart] = useState(null);
  const [g, setg] = useState([]);
  const tarifarten = [{ title: "Tarif", bzh: "tarif" }, { title: "Empfehlung", bzh: "empfehlung" }, { title: "Konzept", bzh: "konzept" }]
  const navigate = useNavigate();
  useEffect(() => {
    const fetchVereinData = async () => {
      const body = { token: Token.get(), action: "get" };
      try {
        let response = await post(body, "/gesellschaft");
        if (response === "LOGOUT") {
          navigate("/");
          return;
        }
        setg(JSON.parse(response).result);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    setTimeout(fetchVereinData, 15);
  }, [navigate]);

  function addtarif() {
    let body = {};
    body.token = Token.get();
    body.action = "create";
    body.subkathid = subkathid;
    body.gesellschaftid = gesellschaftid;
    body.name = name;
    body.tarifart = currenttarifart;
    let response = post(body, "/tarife/general");
    if (response == "LOGOUT") {
      navigate("/");
    }
    if (response) {
      navigate("/tarif/" + JSON.parse(response).result + "/" + subkathid);
    }
  }
  return (
    <>
      <Card variant='soft'>
        <Box>
          <Typography level="title-md">Tarif erstellen</Typography>
          <Typography>Geben sie alle nötigen informationen ein.</Typography>
          <Box sx={{ mt: 2 }}>
            <Typography level="title-sm">Name</Typography>
            <Input sx={{ width: "70%" }} value={name} onChange={(e) => setname(e.target.value)} placeholder='Tarif-Name' />
          </Box>
          <Box sx={{ mt: 2 }}>
            <Typography level="title-sm">Gesellschaft</Typography>
            <Autocomplete onChange={(event, newval) => { setgesellschaftid(newval.id); console.log(newval.id) }} sx={{ width: "70%" }} options={g} getOptionLabel={(item) => item.name} />
          </Box>
          <Box sx={{ mt: 2 }}>
            <Typography level="title-sm">Tarifart</Typography>
            <Autocomplete onChange={(event, newval) => { setcurrenttarifart(newval.bzh); console.log(newval.bzh); }} sx={{ width: "70%" }} options={tarifarten} getOptionLabel={(item) => item.title} />
          </Box>
        </Box>
        <Button sx={{ height: "5%", mt: 1, width: "8%" }}
          startDecorator={<SaveOutlinedIcon />}
          onClick={() => {


            addtarif();

          }}
        >Speichern</Button>

      </Card>



    </>
  )
}

export default CreateTarifform
